import { queryFnNotificationWrapper } from '@ankr.com/utils/queryFnNotificationWrapper';

import { NotificationActions } from 'domains/notifications/store/NotificationActions';
import { getErrorMessage } from 'modules/common/utils/getErrorMessage';

export const getQueryWithErrorNotification = queryFnNotificationWrapper({
  onNotification({ api, error, onError }) {
    const { dispatch, endpoint } = api;

    const errorMessage =
      typeof onError === 'function' ? onError(error) : getErrorMessage(error);

    dispatch(
      NotificationActions.showNotification({
        key: endpoint,
        message: errorMessage,
        severity: 'error',
      }),
    );
  },
});
